<script>
import ModalCoursePublicActivityComponent from '../features/modals/ModalCoursePublicActivityComponent';
export default {
  name: 'ModalCoursePublicActivityView',
  extends: ModalCoursePublicActivityComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    :title="formData.title"
    width="42%"
    class="course-public-activity-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-row v-if="formData">
      <el-col
        :span="24"
        align="center"
      >
        <div
          style="padding:20px;"
          v-html="formData.description"
        />
        <iframe
          v-if="formData.videoUrl"
          :src="formData.videoUrl"
          width="750"
          height="450"
          frameborder="0"
          allow="autoplay; fullscreen; unload"
          allowfullscreen
        />
        <iframe
          v-if="currentPdfViewer"
          id="file-wrapper-viewer"
          :src="currentPdfViewer"
          width="750"
          height="450"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          @load="onBindFileContextMenu"
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>
